<script lang="ts">
    import TmemController from "./TmemController.svelte";
    import TmemCriteria from "./TmemCriteria.svelte";

    import TmemItemMenusInit from "./TmemItemMenusInit.svelte";

    let container = document.getElementById("examples");
    let criteriaContainer = document.getElementById("authors_filter");

    if (container) {
        let controller: TmemController | undefined;
        [...container.querySelectorAll("button, input")].forEach((elem) => {
            elem.addEventListener("click", () => {
                if (!controller) {
                    controller = new TmemController({
                        target: container,
                    });
                    new TmemCriteria({ target: criteriaContainer });
                }
            });
        });
    }

    const tryReloadingTmemOnClientSide = document.getElementById('tmem-error-try-reloading');
    if (tryReloadingTmemOnClientSide) {
        let observer: IntersectionObserver | undefined;
        let triedReloading = false;

        function reloadTmemOnceIfButtonIsVisible(
            intersectionEntries: IntersectionObserverEntry[]
        ) {
            let isVisible = intersectionEntries.reduce(
                (visible, entry) => visible || entry.isIntersecting,
                false
            );
            if (isVisible && !triedReloading) {
                observer.disconnect();
                triedReloading = true;
                tryReloadingTmemOnClientSide.click();
            }

        }

        observer = new IntersectionObserver(reloadTmemOnceIfButtonIsVisible);
        observer.observe(tryReloadingTmemOnClientSide);


    }
</script>

<TmemItemMenusInit />
